const escrowWalletEN = {
    "view": {
        "title": "Manage Your Escrow Wallet",
        "descriptionParagraph1": "Funds are withheld to ensure safety and transparency during the verification process. For flagged tracks, a fee of <strong>15 €</strong> per track is held in escrow to whitelist the track for delivery to Spotify. These funds will be refunded once the track’s artists are verified as legitimate.",
        "descriptionParagraph2": "Use the table below to view all escrow transactions. For more details, <1><strong>Learn More</strong></1>",
        "label": {
            "totalWithheld": "Total Withheld",
            "totalRefunds": "Total Refunds"
        },
        "escrowPayments": {
            "title": "Escrow Payments",
            "table": {
                "column": {
                    "paymentId": "Payment ID",
                    "releaseName": "Release",
                    "amount": "Amount",
                    "paymentDate": "Payment Date",
                    "paymentAgreement": "Payment Agreement",
                    "refundProcessed": "Refund Processed",
                    "requestRefund": "Request Refund",
                    "details": "Details",
                },
                "placeholder": {
                    "search": "Search..."
                },
                "button": {
                    "download": "Download",
                    "exportCsv": "Export CSV",
                    "view": "View",
                    "requestRefund": "Request Refund",
                },
                "label": {
                    "notAvailable": "Not Available",
                },
                "modal": {
                    "requestRefund": {
                        "header": "Request Refund",
                        "body": {
                            "description": "Are you sure you want to request a refund for this payment?",
                            "note": "Please note this request is subject to review by the admin and, if approved, will be added as a statement for which you can issue an invoice.",
                        },
                        "button": {
                            "confirm": "Confirm",
                            "cancel": "Cancel",
                        },
                        "message": {
                            "success": "Refund Request submitted successfully!",
                            "error": "Something went wrong, please try again later!",
                        }
                    }
                }
            },
        },
        "escrowPaymentBreakdown": {
            "title": "Escrow Payment Breakdown",
            "table": {
                "column": {
                    "paymentId": "Payment ID",
                    "trackName": "Track",
                    "amount": "Amount",
                    "paymentDate": "Payment Date",
                },
            },
        },
        "escrowRefunds": {
            "title": "Escrow Refunds",
            "table": {
                "column": {
                    "refundId": "Refund ID",
                    "paymentId": "Payment ID",
                    "release": "Release",
                    "amount": "Amount",
                    "requestDate": "Request Date",
                    "status": "Status",
                },
                "label": {
                    "pending": "Pending",
                    "approved": "Approved",
                    "rejected": "Rejected",
                },
                "tooltip": {
                    "pending": "Your refund request is currently pending for admin review and will be processed soon.",
                    "approved": "Your refund request has been approved and a statement has been added for the refund amount.",
                    "rejected": "Your refund request has been rejected by the admin, you can request for Refund again.",
                },
                "placeholder": {
                    "search": "Search..."
                },
                "button": {
                    "exportCsv": "Export CSV"
                }
            }
        }
    },
    "transactionSuccess": {
        "view": {
            "title": "Transaction Successful :)",
            "description": "Escrow Payment has been successfully completed, relevant release will be whitelisted shortly!",
            "button": {
                "returnToDashboard": "Return to Dashboard",
            }
        }
    },
    "transactionFailure": {
        "view": {
            "title": "Transaction Cancelled :(",
            "description": "The transaction was cancelled... Please try again later!",
            "button": {
                "returnToDashboard": "Return to Dashboard",
            }
        }
    }
};

export default escrowWalletEN;